import { memo } from "react";
import * as Styled from "./style";
import { useRouter } from "next/router";
import { MyMenuItem } from "~/components/blocks/layout/global-navi/desktop/left/dmm-menu/nav-menus/my-menu-item";
import { VideoMenuItem } from "~/components/blocks/layout/global-navi/desktop/left/dmm-menu/nav-menus/video-menu-item";
import { getParentDir } from "~/components/blocks/layout/global-navi/util/getParentDir";
import { EXTERNAL_PATHS, PATHS } from "~/const/paths";
import { useWelcomePageUrl } from "~/hooks/use-welcome-page-url";
import { G_ServicePlan } from "~/lib/graphql";
import { sendTrackingClickCommon } from "~/lib/tracking/events";
import { useAuth } from "~/provider/auth";

export const NavMenus = memo(() => {
  const { asPath } = useRouter();
  const { isLoggedIn, servicePlan } = useAuth();
  const welcomePageUrl = useWelcomePageUrl();

  return (
    <Styled.ULContainer>
      <VideoMenuItem isActive={asPath.startsWith(getParentDir(PATHS.VOD))} />
      <MyMenuItem isActive={asPath.startsWith(getParentDir(PATHS.MY_BOOKMARK))} needsAuth={!isLoggedIn} />
      {(servicePlan === G_ServicePlan.Free || servicePlan === undefined) && (
        <Styled.ListPremiumFree>
          <a href={welcomePageUrl}>プレミアム無料体験</a>
        </Styled.ListPremiumFree>
      )}
      {servicePlan === G_ServicePlan.Premium && (
        <Styled.ListPremiumFree>
          <a
            href={EXTERNAL_PATHS.BENEFIT}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              sendTrackingClickCommon({
                clickEventName: "dmmtv_premiumsite_pc",
              });
            }}
          >
            プレミアム会員特典
          </a>
        </Styled.ListPremiumFree>
      )}
    </Styled.ULContainer>
  );
});

NavMenus.displayName = "NavMenus";
